const sha512 = require('js-sha512');

export function salt() {
  return Math.random().toString(36).substring(2);
}

export function hash(password, salt) {
  var digest = (password || '') + (salt || '');
  for (var i = 0; i < 20; i++) {
    digest = sha512(digest);
  }
  return digest;
}

export function check(password, crypt, salt) {
  return hash(password, salt) == crypt;
}

export function checkContentSettingsForChangesOnSave(data) {
  // This method works against the UI's implementation of content_settings for
  // storing the cryptblock.
  if (data.cryptblock && data.cryptblock.__password__) {
    // Password changed; regenerate salt/hash
    const s = salt();
    data.cryptblock = {
      salt: s,
      crypt: hash(data.cryptblock.__password__, s),
    };
  } else if (data.cryptblock && data.cryptblock.crypt && data.cryptblock.salt) {
    // Keep existing password block as-is
  } else {
    delete data.cryptblock;
  }
  return data;
}



// WEBPACK FOOTER //
// ./app/utils/password.js